import React, { Component } from "react";
import { Calendar, momentLocalizer, Navigate, Views } from "react-big-calendar";
import SegmentedItem from "./SegmentedItem";
import EventDetailDrawer from "./EventDetailDrawer";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "moment/locale/es";

moment.locale("es");
const localizer = momentLocalizer(moment);

const VISTAS_OPTIONS = [
  { label: "Mes", value: Views.MONTH },
  { label: "Semana", value: Views.WEEK },
  { label: "Día", value: Views.DAY },
  { label: "Agenda", value: Views.AGENDA },
];

const NAV_OPTIONS = [
  { label: "Ant.", value: Navigate.PREVIOUS },
  { label: "Hoy", value: Navigate.TODAY },
  { label: "Sig.", value: Navigate.NEXT },
];

const mensajesEspañol = {
  next: "Sig.",
  previous: "Ant.",
  today: "Hoy",
  month: "Mes",
  week: "Semana",
  day: "Día",
  agenda: "Agenda",
  date: "Fecha",
  time: "Hora",
  event: "Evento",
  allDay: "Todo el día",
  noEventsInRange: "No hay eventos en este rango.",
  showMore: (total) => `+ Ver más (${total})`,
};

const CustomToolbar = ({ label, view, onView, onNavigate }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      paddingBottom: 16,
      flexWrap: "wrap",
      gap: 8,
    }}
  >
    {/* Navegación */}
    <SegmentedItem
      options={NAV_OPTIONS}
      onChange={onNavigate}
      defaultValue={Navigate.TODAY}
    />

    {/* Título */}
    <span
      style={{
        fontWeight: 600,
        fontSize: 15,
        color: "#1a1a1a",
        textTransform: "capitalize",
      }}
    >
      {label}
    </span>

    {/* Vistas */}
    <SegmentedItem options={VISTAS_OPTIONS} value={view} onChange={onView} />
  </div>
);

const EventoCalendario = ({ event }) => {
  const color = event.color || "#9b9b9b";

  return (
    <div
      style={{
        padding: "2px 6px",
        height: "28px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {/* Subtítulo del evento — color de la etapa + puntito. En el CRM es el nombre del lead; en
          Hotelería, el número de habitación. `leadNombre` se conserva como respaldo para no romper
          a quien ya lo mandaba. */}
      {(event.subtitulo || event.leadNombre) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            flexShrink: 0,
            minWidth: 0,
          }}
        >
          <span
            style={{
              flexShrink: 0,
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: color,
              display: "inline-block",
            }}
          />
          <span
            style={{
              fontSize: 9,
              fontWeight: 700,
              color: "#000000",
              textDecoration: event.completado ? "line-through" : "none",
              opacity: event.completado ? 0.45 : 1,
              whiteSpace: "normal",
              overflow: "hidden",
              lineHeight: 1.3,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              minWidth: 0,
            }}
          >
            {event.subtitulo || event.leadNombre}
          </span>
        </div>
      )}

      <div
        style={{
          fontSize: 11,
          fontWeight: 500,
          color: "#1a1a1a",
          textDecoration: event.completado ? "line-through" : "none",
          opacity: event.completado ? 0.45 : 1,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: 1.3,
        }}
      >
        {event.title}
      </div>
    </div>
  );
};

const calendarStyles = `

  .rbc-calendar .rbc-event,
  .rbc-calendar .rbc-event.rbc-selected,
  .rbc-calendar .rbc-day-slot .rbc-event {
    box-shadow: none !important;
    padding: 0 !important;
    outline: none !important;
  }

  .rbc-event-inner {
    width: 100%;
    height: 100%;
    background: #fafafa;
    border-radius: 5px;
    box-sizing: border-box;
    overflow: hidden;
  }


  /* ── Header días ── */
  .rbc-header {
    border-bottom: 2px solid #f0f0f0;
    padding: 8px 4px;
    font-size: 11px;
    font-weight: 600;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .rbc-header + .rbc-header {
    border-left: 1px solid #f0f0f0;
  }

  /* ── Celdas del mes ── */
  .rbc-month-view {
    border: 1.5px solid #f0f0f0;
    border-radius: 12px;
    overflow: hidden;
  }
  .rbc-month-row + .rbc-month-row {
    border-top: 1px solid #f0f0f0;
  }
  .rbc-day-bg + .rbc-day-bg {
    border-left: 1px solid #f0f0f0;
  }
  .rbc-off-range-bg {
    background: #ebebeb;
  }
  .rbc-today {
    background: transparent;
  }

 .rbc-month-row {
  min-height: 160px !important;
  max-height: 180px !important;  
  overflow: hidden;
}

.rbc-row-content {
  min-height: 160px !important;
  max-height: 180px !important;
}

  /* Número del día */
  .rbc-date-cell {
    padding: 6px 8px 2px;
    font-size: 12px;
    font-weight: 500;
    color: #aaa;
  }
  .rbc-date-cell.rbc-now {
    padding: 0 !important;
    font-weight: 500;
    color: #aaa;
  }
  
  .rbc-date-cell > a,
  .rbc-date-cell > a:active,
  .rbc-date-cell > a:visited {
    color: inherit;
    text-decoration: none;
  }

  /* ── Eventos ── */
  .rbc-event:focus {
    outline: none;
  }
  .rbc-event-content {
    width: 100%;
    height: 100%;
  }
  .rbc-show-more {
    color: #00BFD6;
    font-size: 11px;
    font-weight: 600;
    padding: 0 6px;
    background: transparent;
  }
  .rbc-show-more:hover {
    color: #00BFD6;
  }

  .rbc-event-label {
    color: #000000;
    font-size: 10px;
    font-weight: 600;
    padding: 2px 6px 0;
    }

  /* ── Vista semana/día ── */
  .rbc-time-view {
    border: 1.5px solid #f0f0f0;
    border-radius: 12px;
    overflow: hidden;
  }
  .rbc-time-header {
    border-bottom: 2px solid #f0f0f0;
  }
  .rbc-timeslot-group {
    border-bottom: 1px solid #f5f5f5;
    min-height: 40px;
  }
  .rbc-time-slot {
    border-top: none;
  }
  .rbc-label {
    font-size: 10px;
    color: #bbb;
    font-weight: 500;
    padding: 0 6px;
  }
  .rbc-current-time-indicator {
    background: #00BFD6;
    height: 2px;
  }
  .rbc-current-time-indicator::before {
    background: #00BFD6;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    top: -3px;
    left: -4px;
  }

  /* ── Agenda ── */
  .rbc-agenda-view table.rbc-agenda-table {
    border: none;
  }
  .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
    border-bottom: 2px solid #f0f0f0;
    font-size: 11px;
    font-weight: 600;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 8px 12px;
  }
  .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
    border-bottom: 1px solid #f5f5f5;
    font-size: 13px;
    color: #444;
    padding: 8px 12px;
  }
  .rbc-agenda-date-cell {
    font-weight: 600;
    color: #1a1a1a;
  }

  /* ── Popup de "ver más" ── */
  .rbc-overlay {
    border: 1.5px solid #f0f0f0;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.08);
    padding: 8px;
  }
  .rbc-overlay-header {
    font-size: 12px;
    font-weight: 600;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 8px;
    margin-bottom: 6px;
  }
`;

const eventPropGetter = (event) => ({
  style: {
    backgroundColor: `${event.color || "#9b9b9b"}14`,
    border: `1.5px solid ${event.color || "#9b9b9b"}`,
    borderRadius: 6,
    marginBottom: 2,
    cursor: "pointer",
    opacity: event.completado ? 0.6 : 1,
    padding: 0,
  },
});

class CalendarItem extends Component {
  state = {
    detailDrawer: { visible: false, evento: null, fromDay: false },
    calendarKey: 0,
  };

  containerRef = React.createRef();

  componentDidMount() {
    if (!document.getElementById("rbc-custom-styles")) {
      const style = document.createElement("style");
      style.id = "rbc-custom-styles";
      style.textContent = calendarStyles;
      document.head.appendChild(style);
    }
    this.resizeObserver = new ResizeObserver(() => {
      this.setState((prev) => ({ calendarKey: prev.calendarKey + 1 }));
      this.resizeObserver.disconnect();
    });

    if (this.containerRef.current) {
      this.resizeObserver.observe(this.containerRef.current);
    }
  }

  componentWillUnmount() {
    this.resizeObserver?.disconnect();
  }

  handleOpenDetail = (evento, fromDay = false) => {
    if (fromDay)
      this.setState({ dayDrawer: { ...this.state.dayDrawer, visible: false } });
    this.setState({ detailDrawer: { visible: true, evento, fromDay } });
  };

  handleCloseDetail = () => {
    const { fromDay } = this.state.detailDrawer;
    if (fromDay) {
      this.setState({
        detailDrawer: { visible: false, evento: null, fromDay: false },
      });
    } else {
      this.setState({
        detailDrawer: { visible: false, evento: null, fromDay: false },
      });
    }
  };

  render() {
    const {
      events = [],
      messages = mensajesEspañol,
      ...restProps
    } = this.props;

    const DateHeaderCustom = ({ date, label, isOffRange, onDrillDown }) => {
      const eventosDelDia = events.filter((ev) =>
        moment(ev.start).isSame(date, "day"),
      );

      const esHoy = moment(date).isSame(moment(), "day");

      const total = eventosDelDia.length;
      const mostrarBadge = total > 0;

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 8px",
          }}
        >
          {/* NÚMERO DEL DÍA */}
          <span
            onClick={onDrillDown}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "28px",
              height: "28px",
              minWidth: "28px",
              minHeight: "28px",
              padding: 0,
              lineHeight: 1,
              borderRadius: esHoy ? "50%" : "0",
              backgroundColor: esHoy ? "#00BFD6" : "transparent",
              color: esHoy ? "#FFFFFF" : isOffRange ? "#ccc" : "#aaa",
              fontSize: 13,
              fontWeight: esHoy ? 700 : 500,
              cursor: "pointer",
            }}
          >
            {label}
          </span>

          {mostrarBadge && (
            <span
              onClick={onDrillDown}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "28px",
                height: "28px",
                minWidth: "28px",
                minHeight: "28px",
                padding: 0,
                lineHeight: 1,

                background: "#cccccc21",
                color: "#b3b3b3",
                border: "1px solid #cfcfcf40",
                borderRadius: "50%",
                fontSize: 11,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              {total}
            </span>
          )}
        </div>
      );
    };

    return (
      <>
        <EventDetailDrawer
          visible={this.state.detailDrawer.visible}
          evento={this.state.detailDrawer.evento}
          onClose={this.handleCloseDetail}
          onEditar={(evento) => {
            this.handleCloseDetail();
            this.props.onEditarEvento?.(evento);
          }}
          onActualizado={this.props.onActualizado}
          // Las acciones del drawer (completar, comentar, eliminar) pegan a los endpoints del CRM,
          // que es de donde salió. Un módulo que reutilice el calendario con otra colección pasa
          // `soloLectura` y hace las acciones en su propia pantalla.
          soloLectura={this.props.soloLectura}
        />
        <div
          ref={this.containerRef}
          style={{
            height: "110hv",
            padding: "20px",
            backgroundColor: "#ffffff",
            borderRadius: 16,
            boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
            boxSizing: "border-box",
          }}
        >
          <Calendar
            key={this.state.calendarKey}
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            messages={messages}
            style={{ height: "100%" }}
            eventPropGetter={eventPropGetter}
            components={{
              event: EventoCalendario,
              toolbar: CustomToolbar,
              month: {
                dateHeader: DateHeaderCustom,
              },
            }}
            {...restProps}
            popup={false}
            doShowMoreDrillDown={false}
            onSelectEvent={(evento) => this.handleOpenDetail(evento, false)}
          />
        </div>
      </>
    );
  }
}

export default CalendarItem;
